import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=be3b08c4&scoped=true&"
import script from "./user-list.vue?vue&type=script&lang=js&"
export * from "./user-list.vue?vue&type=script&lang=js&"
import style0 from "./user-list.vue?vue&type=style&index=0&id=be3b08c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3b08c4",
  null
  
)

export default component.exports